import { render, staticRenderFns } from "./FU2.vue?vue&type=template&id=6c846998&lang=pug&"
import script from "./FU2.vue?vue&type=script&lang=ts&"
export * from "./FU2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports